/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export enum AssetDataSchema {
  Binary,
  Json,
  MsgPack,
}

export type AssetDataSchemaArgs = AssetDataSchema;

export function getAssetDataSchemaEncoder(): FixedSizeEncoder<AssetDataSchemaArgs> {
  return getEnumEncoder(AssetDataSchema);
}

export function getAssetDataSchemaDecoder(): FixedSizeDecoder<AssetDataSchema> {
  return getEnumDecoder(AssetDataSchema);
}

export function getAssetDataSchemaCodec(): FixedSizeCodec<
  AssetDataSchemaArgs,
  AssetDataSchema
> {
  return combineCodec(getAssetDataSchemaEncoder(), getAssetDataSchemaDecoder());
}
